export default {
  ACCOUNT_MANAGEMENT: "Account Management",
  ADVERTISER_LIST: "Advertiser list",
  ADVERTISERS_MANAGEMENT: "Advertiser Management",
  EXPORT_ADVERTISER_LIST: "Export Advertiser list",
  USER_MANAGEMENT: "User Management",
  PLATFORM: "Platform",
  SETTINGS: "Settings",
  LOGOUT: "Logout",
  TEMPLATE_MANAGEMENT: "Template Management",
  GLOSSARY: "Glossary",
};
